rdefine('app/events/Calendar',['backbone', 'text!events/calendar.html','app/events/month','app/events/times', 'app/events/events'], function(Backbone, template,EventsMonth, Times, Events) {


    return Backbone.Ribs.View.extend({
        className:'events-modal-calendar',
        months:null,
        bindings:{
            '.calendar-self .content-scrollable .mCSB_container':{
                collection:{
                    col:'months',
                    view:EventsMonth
                }
            },
            '.dates-place .heading .dates':{
                text:{
                    data:'cmodel.dates',
                    processor:function(i) {
                        if(!i) {
                            i = 0;
                        }
                        var v=[' Date',' Dates',' Dates'];
                        var cases =  [2, 0, 1, 1, 1, 2];
                        return i+ v[(i%100>4 && i%100<20)? 2: cases[Math.min(i%10, 5)]];
                    }
                }
            },
            '.dates-place .content-scrollable .mCSB_container':{
                collection:{
                    col:'dates',
                    view:Times
                }
            },
            '.betweens': {
                text: {
                    data: ['cmodel.mindate', 'cmodel.maxdate'],
                    processor: function (amin, amax) {
                        if (!amin || !amax) {
                            return '';
                        }
                        if (amin === amax) {
                            return moment(amin).format("MMM DD");
                        }
                        var a = moment(amin);
                        var b = moment(amax);
                        if (a.year() == b.year()) {
                            return a.format("MMM DD") + " - " + b.format("MMM DD");
                        }
                        return a.format("MMM DD, YYYY") + " - " + b.format("MMM DD, YYYY");
                    }
                }
            },
            '.empty-content-display':{
                classes:{
                    active:{
                        data:'cmodel.dates',
                        processor:function(a) { return !a;}
                    }
                }
            },
            '.dates-place .heading .times':{
                text:'cmodel.times'
            }
        },
        dates:null,
        cmodel:null,
        modal:null,
        initialize:function(modal) {
            this.modal = modal;
            modal.modalOpts.buttons = [
                {
                    id:'cancel',
                    event:'close',
                    style:'btn-default',
                    title:LANGUAGE['basic.cancel']
                },
                {
                    id:'apply',
                    event:'',
                    cbs:[_.bind(this.saveToOriginalCollection,this)],
                    style:'btn-primary',
                    title:LANGUAGE['events.calendar.modal.apply']
                }
            ];
            modal.renderButtons();
            var models = _.reduce(modal.modalOpts.config.dates.models, function(a,b) {
                a.push(b.attributes);
                return a;
            },[]);
            this.dates = new Events(models);

            modal.modalOpts.config.dates.on('reload-fast', _.bind(function() {
                var models = _.reduce(modal.modalOpts.config.dates.models, function(a,b) {
                    a.push(b.attributes);
                    return a;
                },[]);
                this.dates.reset(models);
                this.dates.trigger('times');
                this.months.trigger('updates');
                //this.addMonths();
            },this));

            this.cmodel = new Backbone.Ribs.Model({times:0,dates:0,mindate:0,maxdate:0,changed:false});
            this.dates.on("reset times", function(){
                var minDate = null;
                var maxDate = null;
                var r = _.reduce(this.dates.models, function(i,item) {

                    if(item.attributes.active) {
                        i.d++;
                        if(minDate === null) {
                            minDate = item.attributes.id;
                        }
                        if(maxDate === null) {
                            maxDate = item.attributes.id;
                        }
                        if(moment(minDate).isAfter(item.attributes.id)) {
                            minDate = item.attributes.id;
                        }
                        if(moment(maxDate).isBefore(item.attributes.id)) {
                            maxDate = item.attributes.id;
                        }

                        i.t += item.attributes.times.length;
                    }
                    return i;
                },{d:0,t:0});
                this.cmodel.set({mindate:minDate,maxdate:maxDate,dates:r.d, times:r.t,changed:true});
                modal.modalOpts.buttons[1].disabled = false;
                modal.renderButtons();
            }.bind(this));

            this.$el.html(Template7.compile(template)());
            this.months = new Backbone.Ribs.Collection([],{model: Backbone.Ribs.Model});
            this.months.dates = this.dates;

            this.addMonths();
            this.preventBindings();

            _.defer(function(){
                $(this.$el.find('.calendar-self .content-scrollable')[0]).mCustomScrollbar({
                    theme: 'minimal-dark',
                    scrollInertia: 100,
                    axis:'yx',
                    mouseWheel: {
                        enable: true,
                        axis: 'y',
                        preventDefault: true
                    }
                });

                $(this.$el.find('.dates-place .content-scrollable')[0]).mCustomScrollbar({
                    theme: 'minimal-dark',
                    scrollInertia: 100,
                    axis:'yx',
                    mouseWheel: {
                        enable: true,
                        axis: 'y',
                        preventDefault: true
                    }
                });
                this.applyBindings();
            }.bind(this));
        },
        addMonths:function() {
            var from = moment();
            var m = [];
            for(var i=0;i<12;i++) {
                m.push({month:from.format('YYYY-MM'), title: from.format('MMMM YYYY')});
                from.add('1','month');
            }
            this.months.reset(m);
        },
        saveToOriginalCollection:function() {
            var e = _.reduce(this.dates.models, function(a,b) {
                if(b.attributes.active) {
                    a.push(b.attributes);
                }
                return a;
            },[]);
            this.modal.modalOpts.config.dates.reset(e);
            this.modal.modalOpts.config.dates.customset();
            this.modal.hide();
        }
    });
});